import React from 'react';
import { Mail } from 'lucide-react';
import Footer from '../components/Footer';

export default function ContactView() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-between text-gray-200">
      <div className="grow flex flex-col items-center justify-center w-full px-4 py-12">
        <div className="text-center space-y-4 w-full max-w-lg">
          <Mail className="w-16 h-16 text-blue-500 mx-auto mb-4" />
          <h2 className="text-3xl font-bold text-white">Contact the Creator</h2>
          <p className="text-gray-400">
            Have an idea, found a bug, or just want to say hi? Send me a message directly.
          </p>
          
          <div className="mt-8 space-y-4 text-left">
            <input 
              type="text" 
              placeholder="Subject" 
              className="w-full bg-[#121212] border border-gray-800 rounded-lg p-4 text-white focus:border-blue-500 focus:outline-none transition-colors" 
            />
            <textarea 
              rows="6" 
              placeholder="Your message..." 
              className="w-full bg-[#121212] border border-gray-800 rounded-lg p-4 text-white focus:border-blue-500 focus:outline-none transition-colors resize-none"
            ></textarea>
            <button className="bg-blue-600 hover:bg-blue-500 text-white px-6 py-4 rounded-lg font-bold w-full transition-colors shadow-lg shadow-blue-500/20">
              Send Message
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
